import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
import { LabRequisitionStatus } from "src/app/enum/water-lab/LabRequisitionStatus";
import { monthsDropDownValues } from "src/app/enum/water-lab/monthsDropdown";
import { LabRequisitionService, MessageService, UserService } from 'src/app/services';
import {Month, ShippingManifestData, Year  } from 'src/app/models/water-lab/shipping-manifest';
import { LoaderService } from 'src/app/services/loader.service';
import { AccessUserInfo, LabTest, UserDetail, UserLocationFacility } from 'src/app/models';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { CustomDatePipe } from 'src/app/pipes';
@Component({
  selector: 'bart-hostorical-manifest',
  templateUrl: './historical-manifest.component.html',
  styleUrls: ['./historical-manifest.component.scss'],
  providers:[CustomDatePipe]
})
export class HostoricalManifestComponent implements OnInit {
  cols: any[];
  @ViewChild('HistoricalManifestTable', { static: false }) HistoricalManifestTable: Table;
  @Input() selectedFacilityMasterId : any;
  @Input() facilities :UserLocationFacility [];
  months : Month[] = monthsDropDownValues
  years: Year[] ;
  selectedMonth: Month;
  selectedYear: Year;
  isHeaderCheckBoxChecked: boolean;
  selectedManifestData : ShippingManifestData[]=[];
  historicalManifestData: ShippingManifestData[];
  public userInfo: UserDetail;
  isPrintManifest:boolean=false;
  labRequisitionIds: string;
  facilityDisplayName:string;
  shippingDate:Date=new Date();
  manifestPrintArr:any=[];
  constructor(
    private _requisitionService : LabRequisitionService,
    private _loaderService : LoaderService,
    private _userService:UserService,
    private customDatePipe :CustomDatePipe,
    private _messageService : MessageService
    ) {
      this.userInfo = AccessUserInfo.getUserInfo();
     }

  ngOnInit()
  {
      this.cols = [
        { field: 'ShippingDate', header: 'Shipped Date & Time' ,display: 'table-cell', width: "24%" },
        { field: 'LabRequisitionNumber', header: 'Requisition ID',display: 'table-cell', width: "20%" },
        { field: 'TestDisplayName', header: 'Test ID | Name',display: 'table-cell', width: "20%" },
        { field: 'EquipmentPrintManifest', header: 'Model # | Serial # | Equipment ID',display: 'table-cell', width: "20%" },  
    ];
  }
  ngOnChanges(changes: SimpleChanges) 
  {
    let currentValue:any;
    let previousValue:any;
    if(changes && changes.selectedFacilityMasterId)
    {
      previousValue=changes.selectedFacilityMasterId.previousValue
      currentValue=changes.selectedFacilityMasterId.currentValue
      if(previousValue!=currentValue)
      {
         this.facilityChanged();
         
      }
    }
    
  }
  facilityChanged()
  {
    const  currenentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth()+1
    let years = [0, 1, 2,].map((count) => `${currenentYear - count}`);    
    this.years = years.map((str, index) => ({ name: str, key: index + 1 }));
    this.months.forEach(item =>
      {
        if(item.number == currentMonth){
          this.selectedMonth = item
        }
      })
      this.years.forEach(item =>{
        if(item.name == currenentYear){
          this.selectedYear = item
        }
      })
    this.getHistoricalMenifestData(this.selectedMonth,this.selectedYear);
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "Filter_JSON",
      value:JSON.stringify( {
        selectedFacility :this.selectedFacilityMasterId,
        selectedMonth : this.selectedMonth.name,
        selectedYear : this.selectedYear.name,
      }),
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_GRID_LOADED
    });
  }

  rowCheckBoxChecked() {
    this.manageCheckBoxSelection();
  }
  manageCheckBoxSelection() 
  {
    let pageOfItems = this.historicalManifestData ? this.historicalManifestData.slice(this.HistoricalManifestTable.first, (this.HistoricalManifestTable.first + this.HistoricalManifestTable.rows)) : [];
    if(this.HistoricalManifestTable.filteredValue)
    {
      pageOfItems=this.HistoricalManifestTable.filteredValue.slice(this.HistoricalManifestTable.first, (this.HistoricalManifestTable.first + this.HistoricalManifestTable.rows));
    }
    let activeObjA = pageOfItems;
    let activeObjB = this.selectedManifestData.filter(ar => activeObjA.find(rm => (rm.LabRequisitionID === ar.LabRequisitionID)))
    
    if (activeObjA.length == activeObjB.length && activeObjA.length > 0) 
    {
      this.isHeaderCheckBoxChecked = true;
    }
    else 
    {
      this.isHeaderCheckBoxChecked = false;
    }
    
  }
  getHistoricalMenifestData(month,year)
  {
 
    
    this._loaderService.show();
    let param =
    {
      "GETLABREQUISITIONS": 
      {
        "FacilityMasterID":this.selectedFacilityMasterId, 
        "LabRequisitionStatusID":LabRequisitionStatus.Shipped +","+ LabRequisitionStatus.Completed,
        "Month": month.number,
        "Year": year.name
      }
    }
    this.resetTable();
    this._requisitionService.getLabRequisitions(param).subscribe(response =>
    {
      this.historicalManifestData = response.getLabRequisitions;
      this.historicalManifestData.forEach(item =>{
        item.ShippingDateSort=new Date (this.customDatePipe.transform(item.ShippingDate,"local","MM/dd/yyyy hh:mm a"));
        item.ShippingDate=this.customDatePipe.transform(item.ShippingDate,"local","MM/dd/yyyy hh:mm a");
        item.ProfileTestJSON=this.getProfileTestToolTiopOnHover(item.ProfileTestJSON);
      });
      this._loaderService.hide()
      
    })
  }
  headerCheckBoxChecked()
  {
    let pageOfItems = this.historicalManifestData ? this.historicalManifestData.slice(this.HistoricalManifestTable.first, (this.HistoricalManifestTable.first + this.HistoricalManifestTable.rows)) : [];
    if(this.HistoricalManifestTable.filteredValue)
    {
      pageOfItems=this.HistoricalManifestTable.filteredValue.slice(this.HistoricalManifestTable.first, (this.HistoricalManifestTable.first + this.HistoricalManifestTable.rows));
    }
    if (this.isHeaderCheckBoxChecked) 
    {
      let activeObj = pageOfItems;
      this.selectedManifestData = this.selectedManifestData.concat(activeObj);
    }
    else 
    {
      let activeObj = pageOfItems;
      this.selectedManifestData = this.selectedManifestData.filter(ar => !activeObj.find(rm => (rm.LabRequisitionID === ar.LabRequisitionID)))
    }
  }
  resetTable(isTableReset:boolean=true)
   {
    if (this.HistoricalManifestTable && isTableReset) {
      this.HistoricalManifestTable.reset();
    }
    this.selectedManifestData = [];
    this.isHeaderCheckBoxChecked = false;
  }
  onFilter(event)
  {
    this.resetTable(false);
  }
  sortColumn(event)
   {
    this.resetTable(false)
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_COLUMN_SORT
    });
    //#endregion
  }

  onMonthChanged(selectedMonth){
    this.selectedMonth = selectedMonth;
    this.getHistoricalMenifestData(this.selectedMonth,this.selectedYear)
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "Selected_Month",
      value: this.selectedMonth.name,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_MONTH_CHANGED
    });
    //#endregion
    
  }
  onYearChanged(selectedYear){
    this.selectedYear = selectedYear;
    this.getHistoricalMenifestData(this.selectedMonth,this.selectedYear)
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "Selected_Year",
      value: this.selectedYear.name,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_YEAR_CHANGED
    });
    //#endregion
  }
  
  paginate(event) 
  {
    this.manageCheckBoxSelection();
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_PAGE_NO_CLICKED
    });
    //#endregion
  }
  viewManifest(rowData)
  {
    this.manifestPrintArr=[];
    this.facilityDisplayName=this.facilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName;
    this._loaderService.show();
    this.isPrintManifest=true;
    
   let tempPrintArr = this.historicalManifestData.filter(x=>x.ShippingManifestID==Number(rowData.ShippingManifestID));
   this.manifestPrintArr.push({ShippingManifestID:rowData.ShippingManifestID,
   ShippingDate:tempPrintArr[0].ShippingDate,showPrint:true,
   LabRequisitionIds:tempPrintArr.map(a=>a.LabRequisitionID).join(",")}); 
     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "LabRequestID",
      value: this.labRequisitionIds,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_HISTORY_ICON_CLICKED
    });
    //#endregion
  }  
  printManifest()
  {   
    this.manifestPrintArr=[];
    this.facilityDisplayName=this.facilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName;
    this._loaderService.show();
    this.isPrintManifest=true;
    
    let distinct = this.selectedManifestData.filter((x, i, arr) => arr.findIndex(t => t.ShippingManifestID === x.ShippingManifestID) === i);
    let selectedShippingManifestID=distinct.map(y => y.ShippingManifestID).join(",");
    if(selectedShippingManifestID!='' && selectedShippingManifestID.length>0){
      let ShippingManifetsIDArr=selectedShippingManifestID.split(',');
      ShippingManifetsIDArr.forEach(ShippingManifestID=>{
        let tempPrintArr = this.historicalManifestData.filter(x=>x.ShippingManifestID==Number(ShippingManifestID));
        this.manifestPrintArr.push({ShippingManifestID:ShippingManifestID,
        ShippingDate:tempPrintArr[0].ShippingDate,showPrint:true,
        LabRequisitionIds:tempPrintArr.map(a=>a.LabRequisitionID).join(",")});        
      })
    }   


     //#region User Action Audit
     this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.SHIPPING_MANIFEST,
      screenPath:location.pathname,
      key:'RequisitionId',
      value:this.labRequisitionIds,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_PRINT_CLICKED
    }); 
    //#endregion
  }  
  printPDFLoaded(objManiFest)
  {
    this._loaderService.hide();   
    this.isPrintManifest=false; 
    objManiFest.showPrint=false;    
  }
  getProfileTestToolTiopOnHover(profileTestJSON:string)
  {
    let strResult=null
    try
    {
      
      if(profileTestJSON)
      {
        let obj=JSON.parse(profileTestJSON)
        obj .forEach(element => {
          strResult=strResult?strResult+"; "+element.TestDisplayName:element.TestDisplayName
        });
      }
    }
    catch(ex)
    {
      console.log("error: "+ex)
    }
    return strResult;
  } 
}
